module.exports = __webpack_public_path__ + "img/linkd2-3.b18980b5.jpg";